export default __webpack_public_path__ + "static/media/image-study-board-2-w.06641896.png";